import React, { FC } from "react";

import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  width: string;
  height: string;
  fill?: string;
  className?: string;
}

const Notification: FC<Props> = ({
  className,
  height,
  width,
  fill = colors.lapel,
}) => {
  return (
    <Svg
      className={className}
      height={height}
      width={width}
      viewBox="0 0 24 24"
      title="Notification icon"
    >
      <path
        fill={fill}
        d="M20.45,17.33a15.21,15.21,0,0,1-1.69-6.79c0-4.27-1-8.53-7.26-8.53S4.24,6.27,4.24,10.53a15.21,15.21,0,0,1-1.69,6.79A.47.47,0,0,0,3,18H8.5a3,3,0,0,0,6,0H20A.47.47,0,0,0,20.45,17.33ZM11.5,20a2,2,0,0,1-2-2h4A2,2,0,0,1,11.5,20Zm2.82-3H3.82a16,16,0,0,0,1.43-6.47C5.24,5.18,7.06,3,11.5,3s6.26,2.18,6.26,7.53A16,16,0,0,0,19.18,17Z"
      />
    </Svg>
  );
};

export default React.memo(Notification);
